import StaticBackdrop from './StaticBackdrop';
import Svg from './Svg';

import '../styles/prompt.css';
import { SyncReactNode } from '../types';

const Prompt = ({ children }: { children: SyncReactNode }) => (
  <StaticBackdrop>
    <div className="prompt">
      <div className="prompt-header">
        <Svg icon="ramp" />
        <Svg icon="license-vendor" />
        <Svg icon="bow" />
        <Svg icon="marina" />
        <Svg icon="bait-shop" />
      </div>
      {children}
    </div>
  </StaticBackdrop>
);

export default Prompt;
